export default {
    //ProjectsList
    your_created_projects: "Os seus cursos criados",
    new_project: "Novo Curso",
    search_course_placeholder: "Procure o seu curso...",
    projects_name: "NOME DO CURSO",
    update_at: 'Actualizado em ',
    coming_soon: 'Em breve',
    search_your_project: 'Procure o seu curso...',
    project_name: 'Nome do curso',
    loading_projects: 'Carregamento de proyectos...',

    //ProjectEditComponent
    modify_project: 'Modificar o seu curso',
    general: 'Geral',
    layout: 'Template',
    access: 'Acesso',
    branding: 'Branding',
    product_page: 'Página do produto',
    sale: 'Venda',
    seo_text: 'SEO',
    product: 'Produto',

    //CategoriesSlideOverComponent
    categories: 'Categorias',
    text_category: 'Classifique os seus produtos por categoria para facilitar aos seus alunos a compra dos seus cursos.',
    select_category: 'Seleccione a categoria...',
    ebook: 'E-book',
    online_project: 'Curso online',
    blended_learning: 'Curso de aprendizagem mista',
    online_program: 'Programa Online',
    webinar_consulting: 'Webinar / Consultoria online',
    remove_category: 'Remover categoria',
    href_help: 'Gostaria de saber mais sobre as categorias',

    //ProjectEdit
        //CustomCategoriesComponent
        //GeneralComponent
        category: 'Categoria',
        duration: 'Duração',
        featured_product: 'Produto em Destaque',
        publish_project: 'Publicar Projeto',
        delete_project: 'Eliminar projecto',
        warning_delete: 'Advertência!',
        message_delete_project: 'Ao apagar o projecto, perderá permanentemente todos os seus dados.',
        question_delete_project: 'Tem a certeza de que quer eliminar este projecto?',
        delete: 'Eliminar',
        confirmation_delete_project: '(*) Esta caixa é necessária para apagar o projecto.',
        navigation: 'Navegação',
        navigation_free: 'Grátis',
        navigation_secuential: 'Sequencial',
        navigation_without_restriction: 'Sem restrições. O utilizador poderá navegar livremente pelo curso (excluindo cursos com conteúdo gota-a-gota).',
        navigation_completed_restriction: 'O aprendente tem de completar cada unidade de aprendizagem antes de continuar para a unidade seguinte. A conclusão de unidades de aprendizagem pode ser estabelecida de diferentes maneiras.',
        quest_lesson_complete: 'Quando é que será considerada uma lição concluída?',
        lesson_complete_at_visit: 'Quando visitados',
        lesson_at_visit_info: 'Ao entrar numa aula será automaticamente completada no progresso total do curso (por defeito).',
        lesson_complete_at_see: 'Ao visualizar o conteúdo na íntegra',
        lesson_at_see_info: 'Será marcado como concluído quando o conteúdo (vídeo, ebook, podcast) for totalmente visualizado.',
        lesson_complete_on_time: 'Ficando algum tempo',
        lesson_on_time_info: 'A completar em cada aula pelo tempo indicado (HH:mm).',
        automatic_navigation: 'Navegação automática',
        automatic_navigation_disabled: 'Desactivado',
        automatic_navigation_enabled: 'Activado',
        automatic_navigation_info: 'A conclusão do conteúdo de uma lição irá levá-lo para a próxima lição correspondente.',
        //PageComponent
        principal_page: 'Página inicial',
        objects_presentation: 'Apresentação e objectos',
        learning_objectives: 'Não se esqueça de descrever brevemente os objectivos de aprendizagem.',
        teaching_staff: 'Metodologia e pessoal docente',
        public: 'Público',
        content: 'Conteúdo',
        sidebar: 'Barra Lateral',
        //ProductBrandingComponent
        banner: 'Banner',
        upload_banner: 'Carregue o seu banner',
        banner_format: 'PNG, JPG, GIF para 3MB',
        promotional_video: 'Vídeo Promocional',
        video_url: 'URL do vídeo',
        video_info: 'Se tiver um vídeo promocional, coloque aqui a url do vídeo no Youtube ou no Vimeo.',
        //SellComponent
        price_management: 'Gestão de preços',
        sell_price: 'Preço de venda',
        tax: 'Em euros. (-3% de imposto)',
        price_offer: 'Preço da Oferta',
        text_configuration: 'Configuração de texto',
        free_text_button: 'Título do botão de compra livre',
        text_if_free: 'Este título aparecerá se o seu produto for gratuito',
        on_sale: 'Para venda',
        sale_info: 'Se activado, o seu produto estará à venda',

    //SeoComponent
    seo_configuration: 'Configuração SEO',
    seo_title: 'Título SEO',
    slug: 'Slug',
    seo_description: 'Descrição SEO',

    //ProjectListComponent
    featured: 'Destaque',
    classroom: 'Sala de aula',
    slug_text: 'slug',
    project: 'Proyecto',
    projects: 'Proyectos',
    preview: 'Pré-visualização',

    //ProjectAccessComponent
    access_project: 'Acesso ao curso',
    draft: 'Projecto',
    draft_text: 'Este projecto não será apresentado no catálogo e poderá ser editado',
    published: 'Publicado',
    published_text: 'Este projecto é publicado e os utilizadores poderão aceder ao mesmo',
    private: 'Particular',
    private_text: 'Este projecto é privado, os utilizadores deste curso irão inscrever-se manualmente',
    coming_soon_access: 'Em breve',
    coming_soon_access_text: 'Este projecto será apresentado no catálogo do curso, mas não será acessível',
    enrollment_closed: 'Inscrição encerrada',
    enrollment_closed_text: 'Apenas os utilizadores inscritos poderão entrar no curso. O curso irá aparecer no catálogo, mas os novos utilizadores não poderão inscrever-se',
    course_expiration: 'Expiração do curso',
    project_expiration_info: 'O seu curso será acessível durante este período de tempo. No final deste período, aos utilizadores inscritos será negado o acesso ao curso.',
    init_date: 'Data de início',
    project_delete: 'Eliminar',
    init_date_selected: 'Data de início seleccionada',
    end_date: 'Data final',
    date_delete: 'Eliminar',
    end_date_selected: 'Data final seleccionada',

    //ProjectContentComponent
    new_section: 'Nova Secção',
    section_title: 'Título da secção: ',
    create_section: 'Criar secção',
    import_section: 'Secção de importação',
    lesson_title: 'Título da lição:',
    new_lesson: 'Nova lição',

    //AttachProductSlideOverComponent
    attach_product_slide: 'Produto Associado',
    selected_product: 'Produto seleccionado',
    quest_attach_product: 'Quer anexar este produto?',

    //ProjectEditContentComponent
    back: 'Voltar',
    select_type_content: 'Seleccione o tipo de conteúdo',
    type_lesson: 'Tipo de lição: ',
    html_editor: 'Editor de HTML',
    html_info_text: 'Insira o código HTML que pretende exibir na sua lição',
    insert_video_url: 'Inserir o URL do vídeo',
    content_index: 'Índice',
    student_list: 'Liste der Studenten',

    //ProjectLayoutContent
    image: 'Imagem',
    classic_design: 'Olhar clássico',

    //Visibilidad staff (FE-001)
    edit_project: 'Editar curso',

    //Listado de proyectos (FE-003)
    empty_projects_title: 'Ainda não há cursos',
    empty_projects_text: 'Os cursos criados nesta academia aparecerão aqui.',
    export_students: 'Exportar alunos',
    unexpected_error: 'Ocorreu um erro inesperado',

    //Contenedor de edición (FE-005)
    loading_project: 'A carregar o curso...',

    //Secciones del contenido (FE-006)
    course_content: 'Conteúdo do curso',
    section_title_label: 'Título da secção',
    section_title_placeholder: 'Ex.: Introdução',
    section_title_required: 'O título da secção é obrigatório',
    section_created: 'Secção criada',
    section_saved: 'Secção guardada',

    //Estados vacíos y lecciones (FE-008)
    empty_sections_title: 'Este curso ainda não tem conteúdo',
    empty_sections_text: 'Crie uma secção para começar a organizar as lições.',
    empty_lessons: 'Esta secção ainda não tem lições.',
    add_lesson: 'Adicionar lição',
    lesson_title_label: 'Título da lição',
    lesson_title_placeholder: 'Ex.: Boas-vindas ao curso',
    lesson_title_required: 'O título da lição é obrigatório',
    lesson_created: 'Lição criada',
    edit_lesson_content: 'Editar conteúdo da lição',

    //Pantalla de lección (FE-009)
    back_to_content: 'Voltar ao conteúdo',
    loading_lesson: 'A carregar a lição...',

    //Cabecera de lección con contexto (FE-053)
    lesson_breadcrumb: 'Posição da lição no curso',
    section_n: 'Secção {number}',
    lesson_n_of_total: 'Lição {number} de {total}',
    previous_lesson: 'Anterior',
    next_lesson: 'Seguinte',
    previous_lesson_named: 'Lição anterior: {title}',
    next_lesson_named: 'Lição seguinte: {title}',
    course_outline_short: 'Índice',
    course_outline: 'Índice do curso',
    current_lesson: '(lição atual)',
    rename_lesson_named: 'Mudar o nome da lição «{title}»',
    view_as_student: 'Ver como aluno',
    opens_in_new_tab: '(abre num novo separador)',

    lesson_editing_coming_soon: 'A edição do conteúdo das lições estará disponível em breve.',

    //Adjuntar producto (FE-010)
    product_attached: 'Produto associado ao curso',
    product_detached: 'Produto desassociado do curso',

    //Pestaña General (FE-011)
    status_label: 'Estado',
    general_editing_coming_soon: 'A edição dos dados do curso (título, estado, eliminação) estará disponível em breve.',

    //Pestaña Acceso (FE-012)
    enrol_configuration: 'Configuração de matrícula',
    enrol_configuration_empty: 'Clique no botão para criar uma configuração de matrícula. Os alunos iniciarão e terminarão a matrícula no curso de acordo com esta configuração.',
    enrol_configuration_create: 'Configurar matrícula',
    enrol_time_start: 'Tempo de início',
    enrol_time_end: 'Tempo de fim',
    enrol_time_value: 'Quantidade',
    enrol_time_unit: 'Unidade de tempo',
    time_unit_hours: 'Horas',
    time_unit_days: 'Dias',
    time_unit_weeks: 'Semanas',
    time_unit_months: 'Meses',
    time_unit_years: 'Anos',
    enrol_configuration_invalid_value: 'Os tempos devem ser números inteiros iguais ou superiores a 0',
    enrol_configuration_invalid_unit: 'Selecione uma unidade de tempo válida',
    enrol_configuration_saved: 'Configuração de matrícula guardada',
    enrol_configuration_deleted: 'Configuração de matrícula eliminada',

    //Textos del editor de contenido (FE-013)
    drag_section: 'Arraste para reordenar a secção',
    drag_lesson: 'Arraste para reordenar a lição',
    delete_section: 'Eliminar secção',
    delete_lesson: 'Eliminar lição',
    sections_order_saved: 'Ordem das secções guardada',
    sections_order_error: 'Erro ao guardar a ordem das secções',
    lessons_order_saved: 'Ordem das lições guardada',
    lessons_order_error: 'Erro ao guardar a ordem das lições',

    //Claves que faltaban respecto a es (FE-013)
    attached_products: 'Produtos associados',
    attach_product: 'Associar produto',
    loading_attached_products: 'A carregar produtos associados...',
    unattach_product: 'Desassociar produto',
    info_unattach_product: 'Ao desassociar o produto do curso, os alunos que o comprarem não poderão aceder ao curso.',
    quest_unattach_product: 'Tem a certeza de que quer desassociar o produto ',
    no_product_attached: 'NÃO HÁ PRODUTOS ASSOCIADOS',

    // FE-020 · Borrar secciones y lecciones
    delete_section_title: 'Apagar a secção «{title}»?',
    delete_section_message: 'A secção será removida do curso.',
    delete_section_with_lessons_message: 'A secção contém {count} lição(ões) que também serão apagadas. Os alunos deixarão de as ver.',
    delete_lesson_title: 'Apagar a lição «{title}»?',
    delete_lesson_message: 'A lição e o seu conteúdo serão removidos do curso.',
    delete_confirm_button: 'Apagar',
    section_deleted: 'Secção apagada',
    lesson_deleted: 'Lição apagada',

    // FE-021 · Renombrar lecciones
    lesson_saved: 'Lição guardada',

    // FE-022 · Reordenar y mover lecciones
    move_section_up: 'Subir secção',
    move_section_down: 'Descer secção',
    move_lesson_up: 'Subir lição',
    move_lesson_down: 'Descer lição',
    empty_lessons_drop: 'Esta secção ainda não tem lições. Adicione uma ou arraste-a para aqui a partir de outra secção.',

    // FE-023 · Publicar y vista previa gratuita
    status_published: 'Publicada',
    status_draft: 'Rascunho',
    publish_section: 'Publicar secção',
    unpublish_section: 'Despublicar secção',
    publish_lesson: 'Publicar lição',
    unpublish_lesson: 'Despublicar lição',
    section_published: 'Secção publicada',
    section_unpublished: 'Secção despublicada: os alunos deixam de a ver',
    lesson_published: 'Lição publicada',
    lesson_unpublished: 'Lição despublicada: os alunos deixam de a ver',
    free_preview_badge: 'Pré-visualização',
    free_preview_enabled: 'A lição é agora de pré-visualização gratuita',
    free_preview_disabled: 'A lição já não é de pré-visualização gratuita',

    //Editor de lección por bloques (FE-030)
    loading_blocks: 'A carregar o conteúdo da lição...',
    drag_block: 'Arraste para reordenar o bloco',
    move_block_up: 'Subir bloco',
    move_block_down: 'Descer bloco',
    delete_block: 'Remover bloco',
    block_type_not_editable: 'Este tipo de bloco ainda não pode ser editado aqui.',
    add_block: 'Adicionar bloco',
    discard_changes: 'Descartar alterações',
    blocks_load_error: 'Não foi possível carregar o conteúdo da lição',
    blocks_saved: 'Conteúdo da lição guardado',
    blocks_save_error: 'Erro ao guardar o conteúdo da lição',
    block_type_rich_text: 'Texto',
    block_rich_text_required: 'O bloco de texto não pode estar vazio',

    //Barra de guardado y estados del editor (FE-051)
    empty_blocks_title: 'Esta lição ainda não tem conteúdo',
    empty_blocks_text: 'Adicione um bloco de texto, uma página incorporada ou outro tipo para começar.',
    add_first_block: 'Adicionar o primeiro bloco',
    blocks_status_dirty: 'Alterações por guardar',
    blocks_status_saving: 'A guardar...',
    blocks_status_saved_at: 'Guardado às {time}',
    blocks_status_clean: 'Sem alterações',
    blocks_errors_count: '{count} bloco com erros | {count} bloco com erros | {count} blocos com erros',
    blocks_go_to_first_error: 'Ir para o primeiro',
    save_shortcut_title: 'Guardar ({shortcut})',
    save_shortcut_hint: '{shortcut} para guardar',
    discard_confirm_title: 'Descartar as alterações?',
    discard_confirm_text: 'A lição volta a ficar como estava da última vez que a guardou.',

    //Guardado en lote del editor de bloques (FE-055)
    blocks_conflict_title: 'Outra pessoa guardou esta lição',
    blocks_conflict_text: 'As suas alterações continuam no ecrã. Se recarregar, verá a versão guardada e perderá o que não guardou.',
    blocks_conflict_reload: 'Recarregar a lição',
    blocks_conflict_keep: 'Continuar a editar',
    blocks_conflict_status: 'Outra pessoa guardou esta lição. Recarregue para poder guardar.',
    blocks_conflict_fallback: 'Outra pessoa guardou esta lição enquanto a editava.',

    //Insertar y manejar bloques (FE-052)
    block_actions: 'Ações do bloco',
    block_position: 'Bloco {position} de {total}',
    collapse_block: 'Recolher bloco',
    expand_block: 'Expandir bloco',
    duplicate_block: 'Duplicar',
    move_block_first: 'Mover para o início',
    move_block_last: 'Mover para o fim',
    insert_block_after: 'Inserir um bloco depois do bloco {position}',
    block_type_rich_text_description: 'Parágrafos, títulos, listas, ligações e imagens.',
    block_type_embed_description: 'Formulários, documentos ou apresentações de serviços permitidos.',
    block_type_video_description: 'Vídeo do YouTube ou do Vimeo.',
    block_type_quiz_description: 'Perguntas com correção automática.',

    //Bloque de página embebida (FE-050)
    block_type_embed: 'Página incorporada',
    block_embed_url_invalid: 'Escreva o endereço completo da página, a começar por https://',
    block_embed_height_invalid: 'A altura deve ser um número inteiro entre 100 e 3000 píxeis',
    block_embed_domain_not_allowed: 'O domínio {host} não é permitido para incorporar páginas',
    embed_url_label: 'Endereço da página',
    embed_url_placeholder: 'https://docs.google.com/forms/...',
    embed_url_help: 'Apenas páginas https de serviços permitidos, como Google Forms, Google Docs, Microsoft Forms ou Slidebean.',
    embed_height_label: 'Altura (píxeis)',
    embed_height_help: 'Entre {min} e {max}. Se a deixar vazia, é usada a altura predefinida.',
    embed_preview: 'Pré-visualizar',
    embed_preview_title: 'Pré-visualização da página incorporada',
    embed_preview_after_save: 'A pré-visualização aparece quando guardar a lição.',

    //Bloque de imagen (FE-057)
    block_type_image: 'Imagem',
    block_type_image_description: 'Uma imagem com texto alternativo e legenda opcional.',
    block_image_required: 'Carregue uma imagem para este bloco',
    block_image_alt_required: 'Escreva o texto alternativo da imagem',
    block_image_file_invalid: 'A imagem já não está disponível: carregue outra',
    image_choose: 'Escolher imagem',
    image_replace: 'Alterar imagem',
    image_drop_hint: 'ou arraste-a para aqui',
    image_file_help: 'JPG, PNG, GIF ou WebP. Máximo {max} MB.',
    image_uploading: 'A carregar a imagem... {progress} %',
    image_preview_unavailable: 'Não é possível mostrar a pré-visualização da imagem.',
    image_type_invalid: 'Formato não suportado: use JPG, PNG, GIF ou WebP',
    image_too_large: 'A imagem tem mais de {max} MB',
    image_upload_throttled: 'Carregou muitas imagens seguidas. Aguarde um minuto e tente novamente.',
    image_upload_error: 'Não foi possível carregar a imagem. Tente novamente.',
    image_alt_label: 'Texto alternativo (obrigatório)',
    image_alt_help: 'Descreva numa frase o que a imagem mostra e porque é importante na lição, por exemplo «Gráfico de vendas que cresce em cada trimestre de 2025». Não comece por «Imagem de».',
    image_caption_label: 'Legenda (opcional)',

    //Bloque de archivos descargables (FE-058)
    block_type_file: 'Ficheiros para descarregar',
    block_type_file_description: 'Documentos ou outros ficheiros para o aluno descarregar.',
    block_file_required: 'Carregue pelo menos um ficheiro para este bloco',
    block_file_too_many: 'Este bloco tem demasiados ficheiros: remova alguns',
    block_file_invalid: 'Algum ficheiro já não está disponível: remova-o e carregue-o novamente',
    block_file_name_invalid: 'O nome visível de um ficheiro é demasiado longo (máximo 255 caracteres)',
    file_empty: 'Este bloco ainda não tem ficheiros.',
    file_list_label: 'Ficheiros do bloco ({count})',
    file_drag: 'Arrastar para reordenar o ficheiro',
    file_open_new_tab: 'abre num novo separador',
    file_name_label: 'Nome visível (opcional)',
    file_move_up: 'Subir ficheiro',
    file_move_down: 'Descer ficheiro',
    file_remove: 'Remover ficheiro',
    file_missing: 'Este ficheiro já não está disponível. Remova-o do bloco.',
    file_unnamed: 'Ficheiro sem nome',
    file_uploading: 'A carregar... {progress} %',
    file_queued: 'Em espera',
    file_retry: 'Tentar carregar novamente',
    file_dismiss: 'Descartar',
    file_choose: 'Escolher ficheiros',
    file_add_more: 'Adicionar mais ficheiros',
    file_drop_hint: 'ou arraste-os para aqui',
    file_limit_reached: 'Atingiu o máximo de {max} ficheiros neste bloco.',
    file_help: 'PDF, Word, Excel, PowerPoint, OpenDocument, RTF, TXT, CSV, ZIP, imagens (JPG, PNG, GIF, WebP) ou MP3. Até {max} MB por ficheiro e {count} ficheiros por bloco.',
    file_type_invalid: 'Formato não suportado',
    file_too_large: 'O ficheiro tem mais de {max} MB',
    file_too_many: 'Não cabem mais ficheiros: o máximo é {max} por bloco',
    file_upload_throttled: 'Carregou muitos ficheiros seguidos. Aguarde um minuto e tente novamente.',
    file_upload_error: 'Não foi possível carregar o ficheiro. Tente novamente.',

    //Bloque de vídeo (FE-031)
    block_type_video: 'Vídeo',
    block_video_required: 'Carregue um vídeo ou cole uma ligação do YouTube ou Vimeo',
    video_source_label: 'Origem do vídeo',
    video_source_upload: 'Carregar vídeo',
    video_source_embed: 'Ligação do YouTube ou Vimeo',
    video_uploaded: 'Vídeo carregado',
    video_upload_error: 'Erro ao carregar o vídeo',
    video_url_label: 'Ligação do vídeo',
    video_url_placeholder: 'https://www.youtube.com/watch?v=...',
    video_url_help: 'Aceita ligações do YouTube (incluindo Shorts e youtu.be) e do Vimeo.',
    video_preview: 'Pré-visualizar',
    video_url_unsupported: 'A ligação não é do YouTube nem do Vimeo ou não é válida',
    video_url_error: 'Não foi possível verificar a ligação do vídeo',

    //Editor de quizzes (FE-033)
    block_type_quiz: 'Quiz',
    block_quiz_required: 'Crie o quiz antes de guardar',
    quiz_empty: 'Este bloco ainda não tem um quiz.',
    quiz_create: 'Criar quiz',
    quiz_default_title: 'Quiz',
    quiz_created: 'Quiz criado. Guarde a lição para o manter neste bloco.',
    quiz_loading: 'A carregar o quiz...',
    quiz_load_error: 'Não foi possível carregar o quiz',
    retry: 'Tentar novamente',
    quiz_save_error: 'Erro ao guardar o quiz',
    quiz_settings_saved: 'Definições do quiz guardadas',
    quiz_title_label: 'Título do quiz',
    quiz_pass_percentage_label: 'Nota mínima para aprovar (%)',
    quiz_max_attempts_label: 'Tentativas máximas',
    quiz_unlimited: 'Ilimitadas',
    quiz_max_attempts_help: 'Deixe vazio para permitir tentativas ilimitadas.',
    quiz_required_to_progress: 'Obrigatório aprovar para avançar',
    quiz_shuffle: 'Baralhar perguntas e respostas',
    quiz_save_settings: 'Guardar definições',
    quiz_title_required: 'O título do quiz é obrigatório',
    quiz_pass_percentage_invalid: 'A nota mínima deve ser um número inteiro entre 0 e 100',
    quiz_max_attempts_invalid: 'As tentativas devem ser um número inteiro maior que 0',
    quiz_questions_title: 'Perguntas ({count})',
    quiz_no_questions: 'Adicione pelo menos uma pergunta.',
    quiz_add_question: 'Adicionar pergunta',
    quiz_edit_question: 'Editar pergunta',
    quiz_delete_question: 'Eliminar pergunta',
    quiz_delete_question_title: 'Eliminar esta pergunta?',
    quiz_delete_question_text: 'A pergunta e as respostas serão eliminadas do quiz. Esta ação não pode ser anulada.',
    quiz_question_saved: 'Pergunta guardada',
    quiz_question_deleted: 'Pergunta eliminada',
    quiz_drag_question: 'Arraste para reordenar a pergunta',
    quiz_move_question_up: 'Subir pergunta',
    quiz_move_question_down: 'Descer pergunta',
    quiz_order_error: 'Erro ao guardar a ordem das perguntas',
    quiz_remove_block_title: 'Remover o bloco de quiz?',
    quiz_remove_block_text: 'Ao guardar a lição, o quiz será eliminado com as suas perguntas e as tentativas dos alunos. Até guardar, pode descartar as alterações para o recuperar.',
    quiz_orphan_delete_error: 'A lição foi guardada, mas não foi possível eliminar o quiz de um bloco removido. Será tentado novamente da próxima vez que guardar.',
    quiz_statement_label: 'Enunciado',
    quiz_question_type_label: 'Tipo de pergunta',
    quiz_type_single: 'Escolha única',
    quiz_type_multiple: 'Escolha múltipla',
    quiz_options_label: 'Respostas',
    quiz_options_help_single: 'Assinale a única resposta correta.',
    quiz_options_help_multiple: 'Assinale todas as respostas corretas.',
    quiz_correct: 'Correta',
    quiz_option_text_label: 'Resposta {number}',
    quiz_option_feedback_label: 'Feedback ao escolhê-la (opcional)',
    quiz_add_option: 'Adicionar resposta',
    quiz_remove_option: 'Remover resposta',
    quiz_explanation_label: 'Explicação (opcional)',
    quiz_explanation_help: 'É mostrada ao aluno depois de responder.',
    quiz_question_type_required: 'Escolha o tipo de pergunta',
    quiz_statement_required: 'O enunciado é obrigatório',
    quiz_min_options: 'Adicione pelo menos duas respostas',
    quiz_option_text_required: 'Todas as respostas devem ter texto',
    quiz_single_requires_one_correct: 'Assinale exatamente uma resposta correta',
    quiz_multiple_requires_correct: 'Assinale pelo menos uma resposta correta',

    // FE-040 · Crear curso desde el panel
    new_course: 'Novo curso',
    new_course_title: 'Criar um curso',
    new_course_text: 'Será criado como rascunho. Depois poderá adicionar o conteúdo e completar a ficha.',
    course_title_label: 'Título do curso',
    course_title_placeholder: 'Ex.: Introdução à fotografia',
    course_title_required: 'O título do curso é obrigatório',
    create_course: 'Criar curso',
    course_created: 'Curso criado',

    // FE-041 · Editar la ficha del curso
    archived: 'Arquivado',
    course_details_loading: 'A carregar a ficha do curso...',
    course_subtitle_label: 'Subtítulo',
    course_description_label: 'Descrição',
    course_cover_label: 'Imagem de capa',
    course_cover_alt: 'Capa do curso',
    course_cover_empty: 'Sem capa',
    course_cover_help: 'Imagem em proporção 16:9 (recomendado 1280×720), até 5 MB.',
    course_cover_invalid: 'Selecione uma imagem com 5 MB no máximo',
    course_slug_label: 'URL amigável (slug)',
    course_slug_help: 'Apenas minúsculas, números e hífenes. Se o deixar vazio, é gerado a partir do título.',
    course_slug_invalid: 'O slug só pode conter minúsculas, números e hífenes',
    course_saved: 'Ficha do curso guardada',

    // FE-042 · Duplicar y borrar curso
    duplicate_course: 'Duplicar curso',
    course_duplicated: 'Curso duplicado. A cópia está em rascunho.',
    delete_course: 'Eliminar curso',
    delete_course_help: 'O curso deixará de estar disponível para os alunos. Esta ação não pode ser anulada a partir do painel.',
    delete_course_title: 'Eliminar este curso?',
    delete_course_text: 'Serão eliminados o curso, as suas secções e as suas lições. O histórico dos alunos é mantido.',
    delete_course_has_students: 'Este curso tem alunos inscritos que perderão o acesso. Se quiser continuar, confirme novamente.',
    delete_course_confirmation_label: 'Para confirmar, escreva o nome do curso:',
    delete_course_force: 'Eliminar mesmo assim',
    course_deleted: 'Curso eliminado',

    // ProjectContentComponent · rediseño del editor de contenido
    sections_count: 'Sem secções | 1 secção | {count} secções',
    lessons_count: 'Sem lições | 1 lição | {count} lições',
    create_lesson: 'Criar lição',
    section_number: 'Título da secção {number}',
    edit_content: 'Editar',
    edit_lesson_content_of: 'Editar o conteúdo de «{title}»',

    //Secciones plegables con resumen (FE-061)
    expand_all_sections: 'Expandir tudo',
    collapse_all_sections: 'Recolher tudo',
    expand_section: 'Expandir a secção «{title}»',
    collapse_section: 'Recolher a secção «{title}»',
    section_actions: 'Ações da secção «{title}»',
    lessons_published_count: 'nenhuma publicada | 1 publicada | {count} publicadas',

    //Programación (drip) dentro de la sección (FE-062)
    drip_menu: 'Programação',
    drip_title: 'Programação da secção',
    drip_help: 'Decida quando os alunos podem ver esta secção.',
    drip_immediate: 'Disponível desde a matrícula',
    drip_days_option: 'Alguns dias depois da matrícula',
    drip_days_label: 'Dias depois da matrícula',
    drip_days_suffix: 'dias depois da matrícula',
    drip_date_option: 'Numa data fixa',
    drip_date_label: 'Data a partir da qual está disponível',
    drip_days_invalid: 'Escreva um número inteiro de dias entre {min} e {max}',
    drip_date_invalid: 'Escolha uma data válida',
    drip_saved: 'Programação da secção guardada',
    drip_badge_days: '{count} dias após a matrícula | 1 dia após a matrícula | {count} dias após a matrícula',
    drip_badge_date: 'Desde {date}',
    drip_edit_of: 'Editar a programação de «{title}»: {schedule}',

    //Filas de lección simplificadas (FE-063)
    lesson_title_edit_hint: 'Clique para mudar o nome. Enter guarda e Escape anula.',
    saved_inline: 'Guardado',
    free_preview_enable: 'Ativar pré-visualização gratuita',
    free_preview_enable_help: 'Qualquer visitante poderá ver esta lição sem comprar o curso.',
    free_preview_disable: 'Remover pré-visualização gratuita',
    lesson_actions: 'Ações da lição «{title}»',

    //Duplicar y acciones en lote (FE-065)
    duplicate_lesson: 'Duplicar',
    duplicate_lesson_help: 'A cópia é criada logo abaixo, em rascunho.',
    duplicate_section: 'Duplicar secção',
    duplicate_section_help: 'Copia a secção com as suas lições logo abaixo, em rascunho.',
    lesson_duplicated: 'Lição duplicada',
    section_duplicated: 'Secção duplicada',
    publish_section_with_lessons: 'Publicar secção e lições',
    unpublish_section_with_lessons: 'Despublicar secção e lições',
    publish_section_with_lessons_title: 'Publicar «{title}» com as suas lições?',
    unpublish_section_with_lessons_title: 'Despublicar «{title}» com as suas lições?',
    publish_section_with_lessons_message: 'A secção será publicada. Todas as suas lições já estão publicadas. | Serão publicadas a secção e {count} lição em rascunho. Os alunos poderão vê-las. | Serão publicadas a secção e {count} lições em rascunho. Os alunos poderão vê-las.',
    unpublish_section_with_lessons_message: 'A secção será despublicada. Nenhuma das suas lições está publicada. | Serão despublicadas a secção e {count} lição publicada. Os alunos deixarão de as ver. | Serão despublicadas a secção e {count} lições publicadas. Os alunos deixarão de as ver.',
    section_with_lessons_published: 'Secção e lições publicadas',
    section_with_lessons_unpublished: 'Secção e lições despublicadas',
    bulk_publish_partial_error: 'Não foi possível alterar nenhum elemento | Não foi possível alterar {count} elemento: verifique o estado e tente novamente. | Não foi possível alterar {count} elementos: verifique o estado e tente novamente.',

    //Currículo en móvil (FE-064)
    rename_section: 'Mudar o nome da secção «{title}»',
    rename_lesson: 'Mudar o nome da lição «{title}»',
}
